import api from "./axios";
import {
  CompetitorCreateInput,
  CompetitorOut,
  CompetitorUpdateInput,
  PaginatedCompetitors,
} from "../types/competitors";

export async function listCompetitors(params: {
  page?: number;
  per_page?: number;
  company_id?: number | null;
  company_hotel_id?: number | null;
  approved?: boolean | null;
  order_by?: string | null;
  order_dir?: "asc" | "desc" | null;
  q?: string | null;
}) {
  const { data } = await api.get<PaginatedCompetitors>("/competitors", {
    params: {
      ...params,
      q: params.q?.trim() || null,
    },
  });
  return data;
}

export async function createCompetitor(
  companyId: number,
  hotelId: number,
  body: CompetitorCreateInput,
) {
  const { data } = await api.post<CompetitorOut>(
    `/companies/${companyId}/hotels/${hotelId}/competitors`,
    body,
  );
  return data;
}

export async function updateCompetitor(
  companyId: number,
  hotelId: number,
  competitorId: number,
  body: CompetitorUpdateInput,
) {
  const { data } = await api.patch<CompetitorOut>(
    `/companies/${companyId}/hotels/${hotelId}/competitors/${competitorId}`,
    body,
  );
  return data;
}

export async function deleteCompetitor(competitorId: number) {
  await api.delete(`/competitors/${competitorId}`);
}

export async function approveCompetitor(competitorId: number, approved = true) {
  const { data } = await api.post<CompetitorOut>(`/competitors/${competitorId}/approve`, null, {
    params: { approved },
  });
  return data;
}

export async function createCompetitorsBulk(companyId: number, hotelId: number, links: string[]) {
  const { data } = await api.post(
    `/companies/${companyId}/hotels/${hotelId}/competitors/bulk`,
    { links },
  );
  return data;
}
